(function ($) {
  $(document).ready(function () {
      
    $('.wrap-search .icon-search-custom').click(function() {
      $('.wrap-search .search .search__input').focus();
    });
    if ($(window).width() < 961) {
     
      
      const initSliderRecomment = () => {
        const sliderRecomment = $(
          ".wrap-product-recomment .box-recomment.mobile"
        );
        if (
          sliderRecomment.length > 0 &&
          !sliderRecomment.hasClass("slick-initialized")
        ) {
          sliderRecomment.slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            
          });
        }

        $(
          ".halo-recommendations-block .header-comment-mobile .prev-slide-comment"
        ).click(function () {
          
          sliderRecomment.slick("slickPrev");
        });
        $(
          ".halo-recommendations-block .header-comment-mobile .next-slide-comment"
        ).click(function () {
          sliderRecomment.slick("slickNext");
        });
      };

      const checkSliderRecomment = setInterval(() => {
        if ($(".wrap-product-recomment .box-recomment.mobile").length > 0) {
          initSliderRecomment();
          clearInterval(checkSliderRecomment);
        }
      }, 500);
      let mainSliderLunettes = $('.section-product-in-page .wrap-product .box-product');
        mainSliderLunettes.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 4000,
          arrows: false,
          dots: false,
          infinite: true,
          swipe: false,
          touchMove: false,
          responsive: [
          {
            breakpoint: 461,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      $('.section-product-in-page .wrap-product .box-content .arrow-slide-inslide.arrow-slide-inslide-prev').click(function(){
          mainSliderLunettes.slick('slickPrev');
      });
      $('.section-product-in-page .wrap-product .box-content .arrow-slide-inslide.arrow-slide-inslide-next').click(function(){
          mainSliderLunettes.slick('slickNext');
      });
      
      let mainSliderGridProduct = $('.slider-product-grid.section-custom.porter-des .wrap-product .box-content .box-product');
        mainSliderGridProduct.slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 4000,
          arrows: false,
          dots: false,
          infinite: true,
          swipe: false,
          touchMove: false,
          responsive: [
            {
              breakpoint: 461,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
      $('.slider-product-grid.section-custom.porter-des .wrap-product .box-content .arrow-slide-inslide.arrow-slide-inslide-prev').click(function(){
          mainSliderGridProduct.slick('slickPrev');
      });
      $('.slider-product-grid.section-custom.porter-des .wrap-product .box-content .arrow-slide-inslide.arrow-slide-inslide-next').click(function(){
          mainSliderGridProduct.slick('slickNext');
      });
    }

    if ($(window).width() < 769) {
      $(".section-5-mobile.des-lignes .wrap-row").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows: true,
        dots: false,
        infinite: true,
      });
     
    }
  });

  $(document).ready(function () {
    $(".collection #main-collection-product-grid .product").each(function () {
      var $product = $(this);
      if (
        $product.find(
          ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
        ).length > 0
      ) {
        $product
          .find(".card-custom .card-information-custom")
          .addClass("is-curent-active");
      }
    });
    $(".wrap-product-recomment .box-product-recomment .product").each(
      function () {
        var $product = $(this);
        if (
          $product.find(
            ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
          ).length > 0
        ) {
          $product
            .find(".card-custom .card-information-custom")
            .addClass("is-curent-active");
        }
      }
    );
    $(
      ".quickSearchResults .predictive-search__results-list .products-grid .product"
    ).each(function () {
      var $product = $(this);
      if (
        $product.find(
          ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
        ).length > 0
      ) {
        $product
          .find(".card-custom .card-information-custom")
          .addClass("is-curent-active");
      }
    });
    function initSliderForProducts() {
      $(
        ".card-custom .card-product__wrapper .card-media-custom .product-slider-custom"
      ).each(function () {
        var $slider = $(this);
        var $cardCustom = $slider.closest(".card-custom");

        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000,
            arrows: true,
            dots: true,
            infinite: true,
          });

          $slider
            .find('.slick-slide[data-slick-index="0"]')
            .addClass("is-active");
          $cardCustom
            .find(".card-information-custom")
            .addClass("is-curent-active");

          $slider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              $slider.find(".slick-slide").removeClass("is-active");
              $cardCustom
                .find(".card-information-custom")
                .removeClass("is-curent-active");

              if (nextSlide === 0) {
                setTimeout(() => {
                  $slider
                    .find('.slick-slide[data-slick-index="0"]')
                    .addClass("is-active");
                  $cardCustom
                    .find(".card-information-custom")
                    .addClass("is-curent-active");
                }, 200);
              }
            }
          );

          $slider.on("afterChange", function (event, slick, currentSlide) {
            $slider
              .find(`.slick-slide[data-slick-index="${currentSlide}"]`)
              .addClass("is-active");
          });
        }
      });
    }
    if ($(window).width() < 1025) {
      function mainSliderGridProductSearch() {
        $('.quickSearchResults .predictive-search__results-list .products-grid').slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: false,
            infinite: false,
            
        });
      }
      let searchCheckInterval;
      $(".search-modal__form .search__input").on("input click", function () {
        if (searchCheckInterval) clearInterval(searchCheckInterval);
  
        searchCheckInterval = setInterval(() => {
          mainSliderGridProductSearch();
          
          $(
            ".quickSearchResults .predictive-search__results-list .products-grid .product"
          ).each(function () {
            var $product = $(this);
            if (
              $product.find(
                ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
              ).length > 0
            ) {
              $product
                .find(".card-custom .card-information-custom")
                .addClass("is-curent-active");
            }
          });
        }, 500);
      });
    }
    function initSliderForProductsSearch() {
      $(
        ".quickSearchResults .predictive-search__results-list .card-custom .card-product__wrapper .card-media-custom .product-slider-custom"
      ).each(function () {
        var $slider = $(this);
        var $cardCustom = $slider.closest(".card-custom");

        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000,
            arrows: true,
            dots: true,
            infinite: true,
            responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: false,
                touchMove: false,
              }
            }
          ]
          });

          $slider
            .find('.slick-slide[data-slick-index="0"]')
            .addClass("is-active");
          $cardCustom
            .find(".card-information-custom")
            .addClass("is-curent-active");

          $slider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              $slider.find(".slick-slide").removeClass("is-active");
              $cardCustom
                .find(".card-information-custom")
                .removeClass("is-curent-active");

              if (nextSlide === 0) {
                setTimeout(() => {
                  $slider
                    .find('.slick-slide[data-slick-index="0"]')
                    .addClass("is-active");
                  $cardCustom
                    .find(".card-information-custom")
                    .addClass("is-curent-active");
                }, 200);
              }
            }
          );

          $slider.on("afterChange", function (event, slick, currentSlide) {
            $slider
              .find(`.slick-slide[data-slick-index="${currentSlide}"]`)
              .addClass("is-active");
          });
        }
      });
    }
    function initSliderForProductsRecomment() {
      $(
        ".card-custom .card-product__wrapper .card-media-custom .product-slider-recomment"
      ).each(function () {
        var $slider = $(this);
        var $cardCustom = $slider.closest(".card-custom");

        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000,
            arrows: true,
            dots: true,
            infinite: true,
            swipe: false,
            touchMove: false,
          });

          $slider
            .find('.slick-slide[data-slick-index="0"]')
            .addClass("is-active");
          $cardCustom
            .find(".card-information-custom")
            .addClass("is-curent-active");

          $slider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              $slider.find(".slick-slide").removeClass("is-active");
              $cardCustom
                .find(".card-information-custom")
                .removeClass("is-curent-active");

              if (nextSlide === 0) {
                setTimeout(() => {
                  $slider
                    .find('.slick-slide[data-slick-index="0"]')
                    .addClass("is-active");
                  $cardCustom
                    .find(".card-information-custom")
                    .addClass("is-curent-active");
                }, 200);
              }
            }
          );

          $slider.on("afterChange", function (event, slick, currentSlide) {
            $slider
              .find(`.slick-slide[data-slick-index="${currentSlide}"]`)
              .addClass("is-active");
          });
        }
      });
    }

    initSliderForProducts();
    initSliderForProductsSearch();
    initSliderForProductsRecomment();

    const targetNode = document.querySelector(
      ".collection #main-collection-product-grid"
    );
    const config = { childList: true, subtree: true };

    const observer = new MutationObserver(function (mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          initSliderForProducts();
          initSliderForProductsSearch();
          $(".collection #main-collection-product-grid .product").each(function () {
      var $product = $(this);
      if (
        $product.find(
          ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
        ).length > 0
      ) {
        $product
          .find(".card-custom .card-information-custom")
          .addClass("is-curent-active");
      }
    });
        }
      }
    });

    if (targetNode) {
      observer.observe(targetNode, config);
    }
    let searchCheckInterval;
    $(".search-modal__form .search__input").on("input click", function () {
      if (searchCheckInterval) clearInterval(searchCheckInterval);

      searchCheckInterval = setInterval(() => {
        initSliderForProductsSearch();
        
        $(
          ".quickSearchResults .predictive-search__results-list .products-grid .product"
        ).each(function () {
          var $product = $(this);
          if (
            $product.find(
              ".card-custom .card-product__wrapper .card-media-custom .product-one-image"
            ).length > 0
          ) {
            $product
              .find(".card-custom .card-information-custom")
              .addClass("is-curent-active");
          }
        });
      }, 500);
    });
  });
})(jQuery);
